module.exports = __webpack_public_path__ + "static/img/1.eaad464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/four/1.png
// module id = ejUG
// module chunks = 1